export default function useKeywordsRanklvl3GridDefaultFilters() {
    return {
        kd: { filter: 85, filterType: "number", type: "lessThanOrEqual" },
        "pos15.traffic": { filter: 1000, filterType: "number", type: "greaterThanOrEqual" },
        "pos18.traffic": { filter: 1000, filterType: "number", type: "greaterThanOrEqual" },
        "pos20.traffic": { filter: 1000, filterType: "number", type: "greaterThanOrEqual" },
        "pos23.traffic": { filter: 1000, filterType: "number", type: "greaterThanOrEqual" },
        "pos25.traffic": { filter: 1000, filterType: "number", type: "greaterThanOrEqual" },
    };
}
